// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyEditWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AgentLicenseType,
  DayOfWeek,
  ForRentByType,
  LeaseDuration,
  ListingAlias,
  PropertyType,
  RentalManagerLaundryType,
  RentalManagerModularListingProgressWebDto,
  UserPropertyEditContactHoursResponseWebDto,
  UserPropertyEditEmailResponseWebDto,
  UserPropertyEditPhoneResponseWebDto,
  UserPropertyEditSecurityDepositResponseWebDto,
  UserPropertyIsConnectedExperienceResponseWebDto,
} from '../..';

interface AdditionalEmailParams {
  additionalEmail?: string;
  listingAlias: ListingAlias;
}
interface AgentLicenseTypeParams {
  agentLicenseType?: AgentLicenseType;
  listingAlias: ListingAlias;
}
interface BalconyDeckPatioPorchParams {
  balconyDeckPatioPorch?: boolean;
  listingAlias: ListingAlias;
}
interface ContactHoursParams {
  contactHours?: string;
  dayOfWeek: DayOfWeek;
  listingAlias: ListingAlias;
}
interface ContactNameParams {
  contactName?: string;
  listingAlias: ListingAlias;
}
interface DisplayTotalMonthlyPriceWithFeeParams {
  displayTotalMonthlyPriceWithFee?: boolean;
  listingAlias: ListingAlias;
}
interface EmailParams {
  email?: string;
  listingAlias: ListingAlias;
}
interface ForRentByParams {
  forRentBy?: ForRentByType;
  listingAlias: ListingAlias;
}
interface HasAirConditioningUtilityIncludedParams {
  hasAirConditioningUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasAssistedLivingParams {
  hasAssistedLiving?: boolean;
  listingAlias: ListingAlias;
}
interface HasAttachedGarageParkingParams {
  hasAttachedGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasBarbecueParams {
  hasBarbecue?: boolean;
  listingAlias: ListingAlias;
}
interface HasBaseboardHeatingSystemParams {
  hasBaseboardHeatingSystem?: boolean;
  propertyId: ListingAlias;
}
interface HasBasketballSportCourtParams {
  hasBasketballSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasBicycleStorageParams {
  hasBicycleStorage?: boolean;
  listingAlias: ListingAlias;
}
interface HasBocceSportCourtParams {
  hasBocceSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasBuildingWideWirelessParams {
  hasBuildingWideWireless?: boolean;
  listingAlias: ListingAlias;
}
interface HasBusinessCenterCommunityRoomParams {
  hasBusinessCenterCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasCableTvParams {
  hasCableTv?: boolean;
  listingAlias: ListingAlias;
}
interface HasCableTvUtilityIncludedParams {
  hasCableTvUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasCarpetFloorCoveringParams {
  hasCarpetFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasCeilingFanParams {
  hasCeilingFan?: boolean;
  listingAlias: ListingAlias;
}
interface HasCentralAirConditioningParams {
  hasCentralAirConditioning?: boolean;
  listingAlias: ListingAlias;
}
interface HasCityViewParams {
  hasCityView?: boolean;
  listingAlias: ListingAlias;
}
interface HasClubHouseCommunityRoomParams {
  hasClubHouseCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasConferenceRoomCommunityRoomParams {
  hasConferenceRoomCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasControlledAccessSecurityParams {
  hasControlledAccessSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasConvectionOvenApplianceParams {
  hasConvectionOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasCoveredParkingParkingParams {
  hasCoveredParkingParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasDeckOutDoorCommonAreaParams {
  hasDeckOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasDetachedGarageParkingParams {
  hasDetachedGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasDisabledAccessParams {
  hasDisabledAccess?: boolean;
  listingAlias: ListingAlias;
}
interface HasDishwasherApplianceParams {
  hasDishwasherAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasDoormanSecurityParams {
  hasDoormanSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasDoubleOvenApplianceParams {
  hasDoubleOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasDryCleaningDropOffParams {
  hasDryCleaningDropOff?: boolean;
  listingAlias: ListingAlias;
}
interface HasElectricHeatingSourceParams {
  hasElectricHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasElectricityUtilityIncludedParams {
  hasElectricityUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasElevatorParams {
  hasElevator?: boolean;
  listingAlias: ListingAlias;
}
interface HasFireplaceParams {
  hasFireplace?: boolean;
  listingAlias: ListingAlias;
}
interface HasFitnessCenterCommunityRoomParams {
  hasFitnessCenterCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasFlexibleLeaseLengthsParams {
  hasFlexibleLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasForcedAirHeatingSystemParams {
  hasForcedAirHeatingSystem?: boolean;
  propertyId: ListingAlias;
}
interface HasFreezerApplianceParams {
  hasFreezerAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasGameRoomCommunityRoomParams {
  hasGameRoomCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasGarbageDisposalApplianceParams {
  hasGarbageDisposalAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasGarbageUtilityIncludedParams {
  hasGarbageUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasGardenOutDoorCommonAreaParams {
  hasGardenOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasGasHeatingSourceParams {
  hasGasHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasGasUtilityIncludedParams {
  hasGasUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasGatedEntrySecurityParams {
  hasGatedEntrySecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasGazeboOutDoorCommonAreaParams {
  hasGazeboOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasGolfCourseViewParams {
  hasGolfCourseView?: boolean;
  listingAlias: ListingAlias;
}
interface HasGuestSuiteParams {
  hasGuestSuite?: boolean;
  listingAlias: ListingAlias;
}
interface HasHardwoodFloorCoveringParams {
  hasHardwoodFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasHeatingUtilityIncludedParams {
  hasHeatingUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasHeatPumpHeatingSourceParams {
  hasHeatPumpHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasHeatPumpHeatingSystemParams {
  hasHeatPumpHeatingSystem?: boolean;
  propertyId: ListingAlias;
}
interface HasHighSpeedInternetParams {
  hasHighSpeedInternet?: boolean;
  listingAlias: ListingAlias;
}
interface HasHotTubParams {
  hasHotTub?: boolean;
  listingAlias: ListingAlias;
}
interface HasHotWaterUtilityIncludedParams {
  hasHotWaterUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasIntercomSecurityParams {
  hasIntercomSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasInternetUtilityIncludedParams {
  hasInternetUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasLaminateFloorCoveringParams {
  hasLaminateFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasLawnOutDoorCommonAreaParams {
  hasLawnOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasLessThanOneYearLeaseLengthsParams {
  hasLessThanOneYearLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasLibraryCommunityRoomParams {
  hasLibraryCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasLinoleumFloorCoveringParams {
  hasLinoleumFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasLoungeCommunityRoomParams {
  hasLoungeCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasMicrowaveOvenApplianceParams {
  hasMicrowaveOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasMonthlyLeaseLengthsParams {
  hasMonthlyLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasMoreThanOneYearLeaseLengthsParams {
  hasMoreThanOneYearLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasMountainViewParams {
  hasMountainView?: boolean;
  listingAlias: ListingAlias;
}
interface HasMultiLevelGarageParkingParams {
  hasMultiLevelGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasMultiPurposeSportCourtParams {
  hasMultiPurposeSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasNightPatrolSecurityParams {
  hasNightPatrolSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasNoneLeaseLengthsParams {
  hasNoneLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasNoneParkingParams {
  hasNoneParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasOilHeatingSourceParams {
  hasOilHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasOneYearLeaseLengthsParams {
  hasOneYearLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasOnlineMaintenancePortalParams {
  hasOnlineMaintenancePortal?: boolean;
  listingAlias: ListingAlias;
}
interface HasOnlineRentPaymentParams {
  hasOnlineRentPayment?: boolean;
  listingAlias: ListingAlias;
}
interface HasOnsiteManagementParams {
  hasOnsiteManagement?: boolean;
  listingAlias: ListingAlias;
}
interface HasOtherSportCourtParams {
  hasOtherSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasOvenApplianceParams {
  hasOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasPackageServiceParams {
  hasPackageService?: boolean;
  listingAlias: ListingAlias;
}
interface HasParkingLotParkingParams {
  hasParkingLotParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasParkViewParams {
  hasParkView?: boolean;
  listingAlias: ListingAlias;
}
interface HasPartyRoomCommunityRoomParams {
  hasPartyRoomCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasPatioBalconyParams {
  hasPatioBalcony?: boolean;
  listingAlias: ListingAlias;
}
interface HasPatioOutDoorCommonAreaParams {
  hasPatioOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasPetParkParams {
  hasPetPark?: boolean;
  listingAlias: ListingAlias;
}
interface HasPetWashingStationCommunityRoomParams {
  hasPetWashingStationCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasPicnicAreaOutDoorCommonAreaParams {
  hasPicnicAreaOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasPlaygroundOutDoorCommonAreaParams {
  hasPlaygroundOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasPropaneButaneHeatingSourceParams {
  hasPropaneButaneHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasRacquetballSportCourtParams {
  hasRacquetballSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasRangeApplianceParams {
  hasRangeAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasRefrigeratorApplianceParams {
  hasRefrigeratorAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasRooftopDeckOutDoorCommonAreaParams {
  hasRooftopDeckOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasSatelliteTvParams {
  hasSatelliteTv?: boolean;
  listingAlias: ListingAlias;
}
interface HasSaunaParams {
  hasSauna?: boolean;
  listingAlias: ListingAlias;
}
interface HasSewageUtilityIncludedParams {
  hasSewageUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasShuffleboardSportCourtParams {
  hasShuffleboardSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasSixMonthsLeaseLengthsParams {
  hasSixMonthsLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasSlateFloorCoveringParams {
  hasSlateFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasSoftwoodFloorCoveringParams {
  hasSoftwoodFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasSolarHeatingSourceParams {
  hasSolarHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasSpanishSpeakingStaffParams {
  hasSpanishSpeakingStaff?: boolean;
  listingAlias: ListingAlias;
}
interface HasSportsFieldSportCourtParams {
  hasSportsFieldSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasStorageSpaceParams {
  hasStorageSpace?: boolean;
  listingAlias: ListingAlias;
}
interface HasSwimmingPoolParams {
  hasSwimmingPool?: boolean;
  listingAlias: ListingAlias;
}
interface HasTennisSportCourtParams {
  hasTennisSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasTerritorialViewParams {
  hasTerritorialView?: boolean;
  listingAlias: ListingAlias;
}
interface HasTheaterCommunityRoomParams {
  hasTheaterCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasTileFloorCoveringParams {
  hasTileFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasTrailOutDoorCommonAreaParams {
  hasTrailOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasTrashCompactorApplianceParams {
  hasTrashCompactorAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasTwentyFourHourMaintenanceParams {
  hasTwentyFourHourMaintenance?: boolean;
  listingAlias: ListingAlias;
}
interface HasUndergroundGarageParkingParams {
  hasUndergroundGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasValetTrashParams {
  hasValetTrash?: boolean;
  listingAlias: ListingAlias;
}
interface HasVinylFloorCoveringParams {
  hasVinylFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasVolleyballSportCourtParams {
  hasVolleyballSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasWallAirConditioningParams {
  hasWallAirConditioning?: boolean;
  listingAlias: ListingAlias;
}
interface HasWallHeatingSystemParams {
  hasWallHeatingSystem?: boolean;
  propertyId: ListingAlias;
}
interface HasWasherDryerHookupsApplianceParams {
  hasWasherDryerHookupsAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasWaterFeatureOutDoorCommonAreaParams {
  hasWaterFeatureOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasWaterUtilityIncludedParams {
  hasWaterUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasWaterViewParams {
  hasWaterView?: boolean;
  listingAlias: ListingAlias;
}
interface HasWindowAirConditioningParams {
  hasWindowAirConditioning?: boolean;
  listingAlias: ListingAlias;
}
interface HasWoodedViewParams {
  hasWoodedView?: boolean;
  listingAlias: ListingAlias;
}
interface HidePhoneParams {
  hidePhone?: boolean;
  listingAlias: ListingAlias;
}
interface HideStreetAddressParams {
  hideStreetAddress?: boolean;
  listingAlias: ListingAlias;
}
interface InterestedInBringingOwnApplicationsParams {
  listingAlias: ListingAlias;
}
interface IsApplicationsAcceptedParams {
  applicationFeeAmount?: number;
  inviteOnly?: boolean;
  isApplicationsAccepted?: boolean;
  propertyId: ListingAlias;
  requireUserName?: boolean;
}
interface IsBrokerExclusiveParams {
  isBrokerExclusive?: boolean;
  listingAlias: ListingAlias;
}
interface IsConnectedExperienceParams {
  listingAlias: ListingAlias;
}
interface IsFurnishedParams {
  isFurnished?: boolean;
  listingAlias: ListingAlias;
}
interface IsIncomeRestrictedParams {
  isIncomeRestricted?: boolean;
  listingAlias: ListingAlias;
}
interface IsOver55Params {
  isOver55?: boolean;
  listingAlias: ListingAlias;
}
interface IsRentersInsuranceRequiredParams {
  isRentersInsuranceRequired?: boolean;
  propertyId: ListingAlias;
}
interface LaundryParams {
  laundry?: RentalManagerLaundryType;
  listingAlias: ListingAlias;
}
interface LeaseDurationParams {
  leaseDuration?: LeaseDuration;
  listingAlias: ListingAlias;
}
interface LeaseTermsParams {
  leaseTerms?: string;
  listingAlias: ListingAlias;
}
interface ModularListingProgressParams {
  listingAlias: ListingAlias;
  step: string;
}
interface NameParams {
  listingAlias: ListingAlias;
  name?: string;
}
interface OffStreetParkingParams {
  listingAlias: ListingAlias;
  offStreetParking?: boolean;
}
interface ParkingDescriptionParams {
  listingAlias: ListingAlias;
  parkingDescription?: string;
}
interface PetPolicyDescriptionParams {
  listingAlias: ListingAlias;
  petPolicyDescription?: string;
}
interface PhoneParams {
  listingAlias: ListingAlias;
  phone?: string;
}
interface PropertyTypeParams {
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
}
interface SecurityDepositParams {
  listingAlias: ListingAlias;
  securityDeposit?: number;
}
interface SmokingAllowedParams {
  listingAlias: ListingAlias;
  smokingAllowed?: boolean;
}
interface UnitsInBuildingParams {
  listingAlias: ListingAlias;
  unitsInBuilding?: number;
}
interface VideoUrlParams {
  listingAlias: ListingAlias;
  videoUrl?: string;
}
interface WebSiteParams {
  listingAlias: ListingAlias;
  webSite?: string;
}
interface WheelchairAccessParams {
  listingAlias: ListingAlias;
  wheelchairAccess?: boolean;
}

export const RentalManagerUserPropertyEditWebApiHandler_additionalEmail_Path =
  '/api/web/v1/users/properties/additionalEmail';

/**
 * Update secondary email of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_additionalEmail = (
  getParams: AdditionalEmailParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AdditionalEmailParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_additionalEmail_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_agentLicenseType_Path =
  '/api/web/v1/users/properties/agentLicenseType';

/**
 * Update agent license type
 */
export const RentalManagerUserPropertyEditWebApiHandler_agentLicenseType = (
  getParams: AgentLicenseTypeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AgentLicenseTypeParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_agentLicenseType_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_balconyDeckPatioPorch_Path =
  '/api/web/v1/users/properties/balconyDeckPatioPorch';

/**
 * Update balcony/deck/patio/porch of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_balconyDeckPatioPorch = (
  getParams: BalconyDeckPatioPorchParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<BalconyDeckPatioPorchParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_balconyDeckPatioPorch_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_contactHours_Path = '/api/web/v1/users/properties/contactHours';

/**
 * Update contact hours for a given day of a MF property
 */
export const RentalManagerUserPropertyEditWebApiHandler_contactHours = (
  getParams: ContactHoursParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ContactHoursParams, never, UserPropertyEditContactHoursResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_contactHours_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_contactName_Path = '/api/web/v1/users/properties/contactName';

/**
 * Update contact name of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_contactName = (
  getParams: ContactNameParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ContactNameParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_contactName_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee_Path =
  '/api/web/v1/users/properties/displayTotalMonthlyPriceWithFee';

/**
 * Update display total monthly price with fee of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee = (
  getParams: DisplayTotalMonthlyPriceWithFeeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DisplayTotalMonthlyPriceWithFeeParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_email_Path = '/api/web/v1/users/properties/email';

/**
 * Update contact email of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_email = (getParams: EmailParams, client = getClient()) => {
  return httpFrontEndRequest<EmailParams, never, UserPropertyEditEmailResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_email_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_forRentBy_Path = '/api/web/v1/users/properties/forRentBy';

/**
 * Update forRentBy of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_forRentBy = (
  getParams: ForRentByParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ForRentByParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_forRentBy_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasAirConditioningUtilityIncluded';

/**
 * Update cooling included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded = (
  getParams: HasAirConditioningUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasAirConditioningUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving_Path =
  '/api/web/v1/users/properties/hasAssistedLiving';

/**
 * Update assisted living of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving = (
  getParams: HasAssistedLivingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasAssistedLivingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking_Path =
  '/api/web/v1/users/properties/hasAttachedGarageParking';

/**
 * Update attached garage parking of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking = (
  getParams: HasAttachedGarageParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasAttachedGarageParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasBarbecue_Path = '/api/web/v1/users/properties/hasBarbecue';

/**
 * Update barbecue of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasBarbecue = (
  getParams: HasBarbecueParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasBarbecueParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasBarbecue_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasBaseboardHeatingSystem_Path =
  '/api/web/v1/users/properties/hasBaseboardHeatingSystem';

/**
 * Update baseboard heating system of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasBaseboardHeatingSystem = (
  getParams: HasBaseboardHeatingSystemParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasBaseboardHeatingSystemParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasBaseboardHeatingSystem_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt_Path =
  '/api/web/v1/users/properties/hasBasketballSportCourt';

/**
 * Update basketball court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt = (
  getParams: HasBasketballSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasBasketballSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage_Path =
  '/api/web/v1/users/properties/hasBicycleStorage';

/**
 * Update bicycle storage of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage = (
  getParams: HasBicycleStorageParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasBicycleStorageParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt_Path =
  '/api/web/v1/users/properties/hasBocceSportCourt';

/**
 * Update bocce court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt = (
  getParams: HasBocceSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasBocceSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless_Path =
  '/api/web/v1/users/properties/hasBuildingWideWireless';

/**
 * Update building wide wireless availability of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless = (
  getParams: HasBuildingWideWirelessParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasBuildingWideWirelessParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom_Path =
  '/api/web/v1/users/properties/hasBusinessCenterCommunityRoom';

/**
 * Update business center of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom = (
  getParams: HasBusinessCenterCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasBusinessCenterCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasCableTv_Path = '/api/web/v1/users/properties/hasCableTv';

/**
 * Update cable tv availability of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasCableTv = (
  getParams: HasCableTvParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasCableTvParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasCableTv_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasCableTvUtilityIncluded';

/**
 * Update cable tv included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded = (
  getParams: HasCableTvUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasCableTvUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering_Path =
  '/api/web/v1/users/properties/hasCarpetFloorCovering';

/**
 * Update carpet flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering = (
  getParams: HasCarpetFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasCarpetFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan_Path =
  '/api/web/v1/users/properties/hasCeilingFan';

/**
 * Update ceiling fan of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan = (
  getParams: HasCeilingFanParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasCeilingFanParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning_Path =
  '/api/web/v1/users/properties/hasCentralAirConditioning';

/**
 * Update central air conditioning of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning = (
  getParams: HasCentralAirConditioningParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasCentralAirConditioningParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasCityView_Path = '/api/web/v1/users/properties/hasCityView';

/**
 * Update city view of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasCityView = (
  getParams: HasCityViewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasCityViewParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasCityView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom_Path =
  '/api/web/v1/users/properties/hasClubHouseCommunityRoom';

/**
 * Update club house of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom = (
  getParams: HasClubHouseCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasClubHouseCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom_Path =
  '/api/web/v1/users/properties/hasConferenceRoomCommunityRoom';

/**
 * Update conference room of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom = (
  getParams: HasConferenceRoomCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasConferenceRoomCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity_Path =
  '/api/web/v1/users/properties/hasControlledAccessSecurity';

/**
 * Update controlled access security of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity = (
  getParams: HasControlledAccessSecurityParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasControlledAccessSecurityParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance_Path =
  '/api/web/v1/users/properties/hasConvectionOvenAppliance';

/**
 * Update convection oven appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance = (
  getParams: HasConvectionOvenApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasConvectionOvenApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking_Path =
  '/api/web/v1/users/properties/hasCoveredParkingParking';

/**
 * Update covered parking of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking = (
  getParams: HasCoveredParkingParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasCoveredParkingParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasDeckOutDoorCommonArea';

/**
 * Update deck of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea = (
  getParams: HasDeckOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasDeckOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking_Path =
  '/api/web/v1/users/properties/hasDetachedGarageParking';

/**
 * Update detached garage parking of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking = (
  getParams: HasDetachedGarageParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasDetachedGarageParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess_Path =
  '/api/web/v1/users/properties/hasDisabledAccess';

/**
 * Update disabled access of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess = (
  getParams: HasDisabledAccessParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasDisabledAccessParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance_Path =
  '/api/web/v1/users/properties/hasDishwasherAppliance';

/**
 * Update dishwasher appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance = (
  getParams: HasDishwasherApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasDishwasherApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity_Path =
  '/api/web/v1/users/properties/hasDoormanSecurity';

/**
 * Update doorman security of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity = (
  getParams: HasDoormanSecurityParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasDoormanSecurityParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance_Path =
  '/api/web/v1/users/properties/hasDoubleOvenAppliance';

/**
 * Update double oven appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance = (
  getParams: HasDoubleOvenApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasDoubleOvenApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff_Path =
  '/api/web/v1/users/properties/hasDryCleaningDropOff';

/**
 * Update dry cleaning drop off of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff = (
  getParams: HasDryCleaningDropOffParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasDryCleaningDropOffParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource_Path =
  '/api/web/v1/users/properties/hasElectricHeatingSource';

/**
 * Update electric heating source of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource = (
  getParams: HasElectricHeatingSourceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasElectricHeatingSourceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasElectricityUtilityIncluded';

/**
 * Update electricity included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded = (
  getParams: HasElectricityUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasElectricityUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasElevator_Path = '/api/web/v1/users/properties/hasElevator';

/**
 * Update elevator of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasElevator = (
  getParams: HasElevatorParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasElevatorParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasElevator_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasFireplace_Path = '/api/web/v1/users/properties/hasFireplace';

/**
 * Update fireplace of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasFireplace = (
  getParams: HasFireplaceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasFireplaceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasFireplace_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom_Path =
  '/api/web/v1/users/properties/hasFitnessCenterCommunityRoom';

/**
 * Update fitness center of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom = (
  getParams: HasFitnessCenterCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasFitnessCenterCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths_Path =
  '/api/web/v1/users/properties/hasFlexibleLeaseLengths';

/**
 * Update flexible lease length of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths = (
  getParams: HasFlexibleLeaseLengthsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasFlexibleLeaseLengthsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasForcedAirHeatingSystem_Path =
  '/api/web/v1/users/properties/hasForcedAirHeatingSystem';

/**
 * Update forced air heating system of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasForcedAirHeatingSystem = (
  getParams: HasForcedAirHeatingSystemParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasForcedAirHeatingSystemParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasForcedAirHeatingSystem_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance_Path =
  '/api/web/v1/users/properties/hasFreezerAppliance';

/**
 * Update freezer appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance = (
  getParams: HasFreezerApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasFreezerApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom_Path =
  '/api/web/v1/users/properties/hasGameRoomCommunityRoom';

/**
 * Update game room of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom = (
  getParams: HasGameRoomCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGameRoomCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance_Path =
  '/api/web/v1/users/properties/hasGarbageDisposalAppliance';

/**
 * Update garbage disposal appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance = (
  getParams: HasGarbageDisposalApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGarbageDisposalApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasGarbageUtilityIncluded';

/**
 * Update garbage included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded = (
  getParams: HasGarbageUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGarbageUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasGardenOutDoorCommonArea';

/**
 * Update garden of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea = (
  getParams: HasGardenOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGardenOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource_Path =
  '/api/web/v1/users/properties/hasGasHeatingSource';

/**
 * Update gas heating source of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource = (
  getParams: HasGasHeatingSourceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGasHeatingSourceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasGasUtilityIncluded';

/**
 * Update gas included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded = (
  getParams: HasGasUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGasUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity_Path =
  '/api/web/v1/users/properties/hasGatedEntrySecurity';

/**
 * Update gated entry security of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity = (
  getParams: HasGatedEntrySecurityParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGatedEntrySecurityParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasGazeboOutDoorCommonArea';

/**
 * Update gazebo of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea = (
  getParams: HasGazeboOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGazeboOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView_Path =
  '/api/web/v1/users/properties/hasGolfCourseView';

/**
 * Update golf course view of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView = (
  getParams: HasGolfCourseViewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGolfCourseViewParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite_Path =
  '/api/web/v1/users/properties/hasGuestSuite';

/**
 * Update guest suite of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite = (
  getParams: HasGuestSuiteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasGuestSuiteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering_Path =
  '/api/web/v1/users/properties/hasHardwoodFloorCovering';

/**
 * Update hardwood flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering = (
  getParams: HasHardwoodFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasHardwoodFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasHeatingUtilityIncluded';

/**
 * Update heat included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded = (
  getParams: HasHeatingUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasHeatingUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource_Path =
  '/api/web/v1/users/properties/hasHeatPumpHeatingSource';

/**
 * Update heat pump heating source of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource = (
  getParams: HasHeatPumpHeatingSourceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasHeatPumpHeatingSourceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSystem_Path =
  '/api/web/v1/users/properties/hasHeatPumpHeatingSystem';

/**
 * Update heat pump heating system of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSystem = (
  getParams: HasHeatPumpHeatingSystemParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasHeatPumpHeatingSystemParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSystem_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet_Path =
  '/api/web/v1/users/properties/hasHighSpeedInternet';

/**
 * Update high speed internet availability of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet = (
  getParams: HasHighSpeedInternetParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasHighSpeedInternetParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasHotTub_Path = '/api/web/v1/users/properties/hasHotTub';

/**
 * Update hot tub of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasHotTub = (
  getParams: HasHotTubParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasHotTubParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasHotTub_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasHotWaterUtilityIncluded';

/**
 * Update hot water included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded = (
  getParams: HasHotWaterUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasHotWaterUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity_Path =
  '/api/web/v1/users/properties/hasIntercomSecurity';

/**
 * Update intercom security of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity = (
  getParams: HasIntercomSecurityParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasIntercomSecurityParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasInternetUtilityIncluded';

/**
 * Update internet included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded = (
  getParams: HasInternetUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasInternetUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering_Path =
  '/api/web/v1/users/properties/hasLaminateFloorCovering';

/**
 * Update laminate flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering = (
  getParams: HasLaminateFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasLaminateFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasLawnOutDoorCommonArea';

/**
 * Update lawn of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea = (
  getParams: HasLawnOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasLawnOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths_Path =
  '/api/web/v1/users/properties/hasLessThanOneYearLeaseLengths';

/**
 * Update less than one year lease length of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths = (
  getParams: HasLessThanOneYearLeaseLengthsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasLessThanOneYearLeaseLengthsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom_Path =
  '/api/web/v1/users/properties/hasLibraryCommunityRoom';

/**
 * Update library of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom = (
  getParams: HasLibraryCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasLibraryCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering_Path =
  '/api/web/v1/users/properties/hasLinoleumFloorCovering';

/**
 * Update linoleum flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering = (
  getParams: HasLinoleumFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasLinoleumFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom_Path =
  '/api/web/v1/users/properties/hasLoungeCommunityRoom';

/**
 * Update lounge of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom = (
  getParams: HasLoungeCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasLoungeCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance_Path =
  '/api/web/v1/users/properties/hasMicrowaveOvenAppliance';

/**
 * Update microwave appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance = (
  getParams: HasMicrowaveOvenApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasMicrowaveOvenApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths_Path =
  '/api/web/v1/users/properties/hasMonthlyLeaseLengths';

/**
 * Update monthly lease length of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths = (
  getParams: HasMonthlyLeaseLengthsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasMonthlyLeaseLengthsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths_Path =
  '/api/web/v1/users/properties/hasMoreThanOneYearLeaseLengths';

/**
 * Update more than one year lease length of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths = (
  getParams: HasMoreThanOneYearLeaseLengthsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasMoreThanOneYearLeaseLengthsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasMountainView_Path =
  '/api/web/v1/users/properties/hasMountainView';

/**
 * Update mountain view of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasMountainView = (
  getParams: HasMountainViewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasMountainViewParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasMountainView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking_Path =
  '/api/web/v1/users/properties/hasMultiLevelGarageParking';

/**
 * Update multi-level garage parking of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking = (
  getParams: HasMultiLevelGarageParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasMultiLevelGarageParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt_Path =
  '/api/web/v1/users/properties/hasMultiPurposeSportCourt';

/**
 * Update multi-purpose sports court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt = (
  getParams: HasMultiPurposeSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasMultiPurposeSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity_Path =
  '/api/web/v1/users/properties/hasNightPatrolSecurity';

/**
 * Update night patrol security of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity = (
  getParams: HasNightPatrolSecurityParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasNightPatrolSecurityParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths_Path =
  '/api/web/v1/users/properties/hasNoneLeaseLengths';

/**
 * Update 'None' lease length of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths = (
  getParams: HasNoneLeaseLengthsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasNoneLeaseLengthsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasNoneParking_Path =
  '/api/web/v1/users/properties/hasNoneParking';

/**
 * Update None parking amenity of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasNoneParking = (
  getParams: HasNoneParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasNoneParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasNoneParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource_Path =
  '/api/web/v1/users/properties/hasOilHeatingSource';

/**
 * Update oil heating source of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource = (
  getParams: HasOilHeatingSourceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasOilHeatingSourceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths_Path =
  '/api/web/v1/users/properties/hasOneYearLeaseLengths';

/**
 * Update one year lease length of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths = (
  getParams: HasOneYearLeaseLengthsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasOneYearLeaseLengthsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal_Path =
  '/api/web/v1/users/properties/hasOnlineMaintenancePortal';

/**
 * Update online maintenance portal of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal = (
  getParams: HasOnlineMaintenancePortalParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasOnlineMaintenancePortalParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment_Path =
  '/api/web/v1/users/properties/hasOnlineRentPayment';

/**
 * Update online rent payment of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment = (
  getParams: HasOnlineRentPaymentParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasOnlineRentPaymentParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement_Path =
  '/api/web/v1/users/properties/hasOnsiteManagement';

/**
 * Update onsite management of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement = (
  getParams: HasOnsiteManagementParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasOnsiteManagementParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt_Path =
  '/api/web/v1/users/properties/hasOtherSportCourt';

/**
 * Update other sports court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt = (
  getParams: HasOtherSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasOtherSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance_Path =
  '/api/web/v1/users/properties/hasOvenAppliance';

/**
 * Update oven appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance = (
  getParams: HasOvenApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasOvenApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPackageService_Path =
  '/api/web/v1/users/properties/hasPackageService';

/**
 * Update package service of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPackageService = (
  getParams: HasPackageServiceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPackageServiceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPackageService_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking_Path =
  '/api/web/v1/users/properties/hasParkingLotParking';

/**
 * Update parking lot of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking = (
  getParams: HasParkingLotParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasParkingLotParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasParkView_Path = '/api/web/v1/users/properties/hasParkView';

/**
 * Update park view of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasParkView = (
  getParams: HasParkViewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasParkViewParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasParkView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom_Path =
  '/api/web/v1/users/properties/hasPartyRoomCommunityRoom';

/**
 * Update party room of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom = (
  getParams: HasPartyRoomCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPartyRoomCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony_Path =
  '/api/web/v1/users/properties/hasPatioBalcony';

/**
 * Update patio balcony of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony = (
  getParams: HasPatioBalconyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPatioBalconyParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasPatioOutDoorCommonArea';

/**
 * Update patio of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea = (
  getParams: HasPatioOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPatioOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPetPark_Path = '/api/web/v1/users/properties/hasPetPark';

/**
 * Update pet park of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPetPark = (
  getParams: HasPetParkParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPetParkParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPetPark_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom_Path =
  '/api/web/v1/users/properties/hasPetWashingStationCommunityRoom';

/**
 * Update pet washing station of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom = (
  getParams: HasPetWashingStationCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPetWashingStationCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasPicnicAreaOutDoorCommonArea';

/**
 * Update picnic area of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea = (
  getParams: HasPicnicAreaOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPicnicAreaOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasPlaygroundOutDoorCommonArea';

/**
 * Update playground of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea = (
  getParams: HasPlaygroundOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPlaygroundOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource_Path =
  '/api/web/v1/users/properties/hasPropaneButaneHeatingSource';

/**
 * Update propane/butane heating source of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource = (
  getParams: HasPropaneButaneHeatingSourceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasPropaneButaneHeatingSourceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt_Path =
  '/api/web/v1/users/properties/hasRacquetballSportCourt';

/**
 * Update racquetball court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt = (
  getParams: HasRacquetballSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasRacquetballSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance_Path =
  '/api/web/v1/users/properties/hasRangeAppliance';

/**
 * Update range appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance = (
  getParams: HasRangeApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasRangeApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance_Path =
  '/api/web/v1/users/properties/hasRefrigeratorAppliance';

/**
 * Update refrigerator appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance = (
  getParams: HasRefrigeratorApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasRefrigeratorApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasRooftopDeckOutDoorCommonArea';

/**
 * Update rooftop deck of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea = (
  getParams: HasRooftopDeckOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasRooftopDeckOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv_Path =
  '/api/web/v1/users/properties/hasSatelliteTv';

/**
 * Update satellite tv availability of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv = (
  getParams: HasSatelliteTvParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSatelliteTvParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSauna_Path = '/api/web/v1/users/properties/hasSauna';

/**
 * Update sauna of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSauna = (
  getParams: HasSaunaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSaunaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSauna_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasSewageUtilityIncluded';

/**
 * Update sewage included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded = (
  getParams: HasSewageUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSewageUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt_Path =
  '/api/web/v1/users/properties/hasShuffleboardSportCourt';

/**
 * Update shuffleboard court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt = (
  getParams: HasShuffleboardSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasShuffleboardSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths_Path =
  '/api/web/v1/users/properties/hasSixMonthsLeaseLengths';

/**
 * Update six month lease length of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths = (
  getParams: HasSixMonthsLeaseLengthsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSixMonthsLeaseLengthsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering_Path =
  '/api/web/v1/users/properties/hasSlateFloorCovering';

/**
 * Update slate flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering = (
  getParams: HasSlateFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSlateFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering_Path =
  '/api/web/v1/users/properties/hasSoftwoodFloorCovering';

/**
 * Update softwood flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering = (
  getParams: HasSoftwoodFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSoftwoodFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource_Path =
  '/api/web/v1/users/properties/hasSolarHeatingSource';

/**
 * Update solar heating source of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource = (
  getParams: HasSolarHeatingSourceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSolarHeatingSourceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff_Path =
  '/api/web/v1/users/properties/hasSpanishSpeakingStaff';

/**
 * Update Spanish speaking staff of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff = (
  getParams: HasSpanishSpeakingStaffParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSpanishSpeakingStaffParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt_Path =
  '/api/web/v1/users/properties/hasSportsFieldSportCourt';

/**
 * Update sports field of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt = (
  getParams: HasSportsFieldSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSportsFieldSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace_Path =
  '/api/web/v1/users/properties/hasStorageSpace';

/**
 * Update storage space of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace = (
  getParams: HasStorageSpaceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasStorageSpaceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool_Path =
  '/api/web/v1/users/properties/hasSwimmingPool';

/**
 * Update swimming pool of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool = (
  getParams: HasSwimmingPoolParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasSwimmingPoolParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt_Path =
  '/api/web/v1/users/properties/hasTennisSportCourt';

/**
 * Update tennis court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt = (
  getParams: HasTennisSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasTennisSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView_Path =
  '/api/web/v1/users/properties/hasTerritorialView';

/**
 * Update territorial view of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView = (
  getParams: HasTerritorialViewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasTerritorialViewParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom_Path =
  '/api/web/v1/users/properties/hasTheaterCommunityRoom';

/**
 * Update theater of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom = (
  getParams: HasTheaterCommunityRoomParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasTheaterCommunityRoomParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering_Path =
  '/api/web/v1/users/properties/hasTileFloorCovering';

/**
 * Update tile flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering = (
  getParams: HasTileFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasTileFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasTrailOutDoorCommonArea';

/**
 * Update trail of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea = (
  getParams: HasTrailOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasTrailOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance_Path =
  '/api/web/v1/users/properties/hasTrashCompactorAppliance';

/**
 * Update trash compactor appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance = (
  getParams: HasTrashCompactorApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasTrashCompactorApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance_Path =
  '/api/web/v1/users/properties/hasTwentyFourHourMaintenance';

/**
 * Update 24 hour maintenance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance = (
  getParams: HasTwentyFourHourMaintenanceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasTwentyFourHourMaintenanceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking_Path =
  '/api/web/v1/users/properties/hasUndergroundGarageParking';

/**
 * Update underground garage parking of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking = (
  getParams: HasUndergroundGarageParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasUndergroundGarageParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasValetTrash_Path =
  '/api/web/v1/users/properties/hasValetTrash';

/**
 * Update valet trash of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasValetTrash = (
  getParams: HasValetTrashParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasValetTrashParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasValetTrash_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering_Path =
  '/api/web/v1/users/properties/hasVinylFloorCovering';

/**
 * Update vinyl flooring of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering = (
  getParams: HasVinylFloorCoveringParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasVinylFloorCoveringParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt_Path =
  '/api/web/v1/users/properties/hasVolleyballSportCourt';

/**
 * Update volleyball court of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt = (
  getParams: HasVolleyballSportCourtParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasVolleyballSportCourtParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning_Path =
  '/api/web/v1/users/properties/hasWallAirConditioning';

/**
 * Update wall air conditioning of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning = (
  getParams: HasWallAirConditioningParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWallAirConditioningParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWallHeatingSystem_Path =
  '/api/web/v1/users/properties/hasWallHeatingSystem';

/**
 * Update heat pump heating system of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWallHeatingSystem = (
  getParams: HasWallHeatingSystemParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWallHeatingSystemParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWallHeatingSystem_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance_Path =
  '/api/web/v1/users/properties/hasWasherDryerHookupsAppliance';

/**
 * Update washer/dryer hookups appliance of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance = (
  getParams: HasWasherDryerHookupsApplianceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWasherDryerHookupsApplianceParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea_Path =
  '/api/web/v1/users/properties/hasWaterFeatureOutDoorCommonArea';

/**
 * Update water feature of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea = (
  getParams: HasWaterFeatureOutDoorCommonAreaParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWaterFeatureOutDoorCommonAreaParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded_Path =
  '/api/web/v1/users/properties/hasWaterUtilityIncluded';

/**
 * Update water included of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded = (
  getParams: HasWaterUtilityIncludedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWaterUtilityIncludedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWaterView_Path = '/api/web/v1/users/properties/hasWaterView';

/**
 * Update water view of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWaterView = (
  getParams: HasWaterViewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWaterViewParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWaterView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning_Path =
  '/api/web/v1/users/properties/hasWindowAirConditioning';

/**
 * Update window air conditioning of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning = (
  getParams: HasWindowAirConditioningParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWindowAirConditioningParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hasWoodedView_Path =
  '/api/web/v1/users/properties/hasWoodedView';

/**
 * Update wooded view of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hasWoodedView = (
  getParams: HasWoodedViewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HasWoodedViewParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hasWoodedView_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hidePhone_Path = '/api/web/v1/users/properties/hidePhone';

/**
 * Update hidePhone of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hidePhone = (
  getParams: HidePhoneParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HidePhoneParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hidePhone_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress_Path =
  '/api/web/v1/users/properties/hideStreetAddress';

/**
 * Update hideStreetAddress of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress = (
  getParams: HideStreetAddressParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<HideStreetAddressParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_interestedInBringingOwnApplications_Path =
  '/api/web/v1/users/properties/interestedInBringingOwnApplications';

/**
 * Set interested in bringing own applications zuid
 */
export const RentalManagerUserPropertyEditWebApiHandler_interestedInBringingOwnApplications = (
  getParams: InterestedInBringingOwnApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<InterestedInBringingOwnApplicationsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_interestedInBringingOwnApplications_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted_Path =
  '/api/web/v1/users/properties/isApplicationsAccepted';

/**
 * Update applications accepted of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted = (
  getParams: IsApplicationsAcceptedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsApplicationsAcceptedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive_Path =
  '/api/web/v1/users/properties/isBrokerExclusive';

/**
 * Update is broker exclusive
 */
export const RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive = (
  getParams: IsBrokerExclusiveParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsBrokerExclusiveParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path =
  '/api/web/v1/users/properties/isConnectedExperience';

/**
 * Get isConnectedExperience for a listing
 */
export const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience = (
  getParams: IsConnectedExperienceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsConnectedExperienceParams, never, UserPropertyIsConnectedExperienceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isFurnished_Path = '/api/web/v1/users/properties/isFurnished';

/**
 * Update furnished of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_isFurnished = (
  getParams: IsFurnishedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsFurnishedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isFurnished_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted_Path =
  '/api/web/v1/users/properties/isIncomeRestricted';

/**
 * Update income restricted of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted = (
  getParams: IsIncomeRestrictedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsIncomeRestrictedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isOver55_Path = '/api/web/v1/users/properties/isOver55';

/**
 * Update over 55 of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_isOver55 = (
  getParams: IsOver55Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsOver55Params, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isOver55_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired_Path =
  '/api/web/v1/users/properties/isRentersInsuranceRequired';

/**
 * Update renters insurance requirement
 */
export const RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired = (
  getParams: IsRentersInsuranceRequiredParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsRentersInsuranceRequiredParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_laundry_Path = '/api/web/v1/users/properties/laundry';

/**
 * Update laundry of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_laundry = (getParams: LaundryParams, client = getClient()) => {
  return httpFrontEndRequest<LaundryParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_laundry_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_leaseDuration_Path =
  '/api/web/v1/users/properties/leaseDuration';

/**
 * Update lease duration of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_leaseDuration = (
  getParams: LeaseDurationParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeaseDurationParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_leaseDuration_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_leaseTerms_Path = '/api/web/v1/users/properties/leaseTerms';

/**
 * Update lease terms of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_leaseTerms = (
  getParams: LeaseTermsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<LeaseTermsParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_leaseTerms_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_modularListingProgress_Path =
  '/api/web/v1/users/properties/modularListingProgress';

/**
 * Save modular listing progress. Pass step='review' to persist that the user reached review.
 */
export const RentalManagerUserPropertyEditWebApiHandler_modularListingProgress = (
  getParams: ModularListingProgressParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ModularListingProgressParams, never, RentalManagerModularListingProgressWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_modularListingProgress_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_name_Path = '/api/web/v1/users/properties/name';

/**
 * Update name of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_name = (getParams: NameParams, client = getClient()) => {
  return httpFrontEndRequest<NameParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_name_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_offStreetParking_Path =
  '/api/web/v1/users/properties/offStreetParking';

/**
 * Update off street parking of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_offStreetParking = (
  getParams: OffStreetParkingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OffStreetParkingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_offStreetParking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_parkingDescription_Path =
  '/api/web/v1/users/properties/parkingDescription';

/**
 * Update parking description of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_parkingDescription = (
  getParams: ParkingDescriptionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ParkingDescriptionParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_parkingDescription_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription_Path =
  '/api/web/v1/users/properties/petPolicyDescription';

/**
 * Update pet policy description of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription = (
  getParams: PetPolicyDescriptionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PetPolicyDescriptionParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_phone_Path = '/api/web/v1/users/properties/phone';

/**
 * Update contact phone of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_phone = (getParams: PhoneParams, client = getClient()) => {
  return httpFrontEndRequest<PhoneParams, never, UserPropertyEditPhoneResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_phone_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_propertyType_Path = '/api/web/v1/users/properties/propertyType';

/**
 * Update propertyType of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_propertyType = (
  getParams: PropertyTypeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PropertyTypeParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_propertyType_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_securityDeposit_Path =
  '/api/web/v1/users/properties/securityDeposit';

/**
 * Update security deposit for a single family listing
 */
export const RentalManagerUserPropertyEditWebApiHandler_securityDeposit = (
  getParams: SecurityDepositParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SecurityDepositParams, never, UserPropertyEditSecurityDepositResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_securityDeposit_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_smokingAllowed_Path =
  '/api/web/v1/users/properties/smokingAllowed';

/**
 * Update smoking allowed of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_smokingAllowed = (
  getParams: SmokingAllowedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SmokingAllowedParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_smokingAllowed_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding_Path =
  '/api/web/v1/users/properties/unitsInBuilding';

/**
 * Update units in building of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding = (
  getParams: UnitsInBuildingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UnitsInBuildingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_videoUrl_Path = '/api/web/v1/users/properties/videoUrl';

/**
 * Update video URL of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_videoUrl = (
  getParams: VideoUrlParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<VideoUrlParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_videoUrl_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_webSite_Path = '/api/web/v1/users/properties/webSite';

/**
 * Update web site of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_webSite = (getParams: WebSiteParams, client = getClient()) => {
  return httpFrontEndRequest<WebSiteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_webSite_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_wheelchairAccess_Path =
  '/api/web/v1/users/properties/wheelchairAccess';

/**
 * Update wheelchair accessibility of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_wheelchairAccess = (
  getParams: WheelchairAccessParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<WheelchairAccessParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_wheelchairAccess_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
